/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createSelector } from 'reselect';

import {
  getWorkspaceViewPlugins,
  groupPlugins,
  selectAllViewPlugins
} from '../../common/selectors';
import { selectSelectedWorkspace } from './workspace.selectors';
import { newEnabledViewPlugins } from '../data/prefabs';

export const selectWorkspaceEnabledViewPlugins = createSelector(
  selectSelectedWorkspace,
  getWorkspaceViewPlugins
);

export const selectViewPluginsGrouped = createSelector(
  selectAllViewPlugins,
  groupPlugins
);

export const selectUpdatedEnabledViewPlugins = createSelector(
  selectWorkspaceEnabledViewPlugins,
  newEnabledViewPlugins.value,
  (saved, updated) => updated || saved || []
);
